import React from 'react';
import { useForm } from "react-hook-form";
import './AddDestination.css';

const axios = require('axios').default;

const AddProject = () => {
    const { register, handleSubmit, reset, formState: { errors } } = useForm();
    const onSubmit = data => {
        console.log(data);
        axios.post('https://immense-tor-98542.herokuapp.com/addprojects', data)
        .then(res => {
            if(res.data.insertedId){
                alert('Data Added Successfully !');
                reset();
            }
        })
    }
    return (
        <div className="adddestination mb-5">
            <h1>Add Projects</h1>
            <form onSubmit={handleSubmit(onSubmit)}>

            <input {...register("projectname", { required: true })} placeholder="Enter Projects Name"/>
            {errors.projectname && <span>This field is required</span>}

            <input {...register("category", { required: true })} placeholder="Enter Projects Category"/>
            {errors.category && <span>This field is required</span>}

            <input {...register("description", { required: true })} placeholder="Enter Description"/>
            {errors.description && <span>This field is required</span>}

            <input {...register("imageUrl", { required: true })} placeholder="Enter image url"/>
            {errors.imageUrl && <span>This field is required</span>}
            
            <input type="submit" />
            </form>
        </div>
    );
};

export default AddProject;